import React, {useContext} from "react"
import {MainContext} from "../helpers/MainContext"

const CTAbutton = ( {CTA = "Устроить просмотр"} ) => {
    const { setObjectFormVisibility } = useContext(MainContext);

    const objectCtaButtonClick = (e) => {
        e.preventDefault();
        // document.getElementsByClassName("imageGallery")[0].style.visibility = "hidden";
        setObjectFormVisibility(true);
    }
    
    return (
        <button className="button CTAbutton" onClick={objectCtaButtonClick} >{CTA}</button>
    )
}

export default CTAbutton;